import React, { useState } from "react";
import "./RefreshIconButton.css";

type RefreshIconButtonProps = {
  onClick: () => void | Promise<void>;
  ariaLabel?: string;
  title?: string;
  disabled?: boolean;
  className?: string;
};

export default function RefreshIconButton({
  onClick,
  ariaLabel = "Refresh",
  title,
  disabled = false,
  className = "",
}: RefreshIconButtonProps) {
  const [isSpinning, setIsSpinning] = useState(false);

  const handleClick = async () => {
    if (disabled || isSpinning) return;
    setIsSpinning(true);
    try {
      await onClick();
    } finally {
      setIsSpinning(false);
    }
  };

  return (
    <button
      type="button"
      className={`refresh-icon-button ${isSpinning ? "spinning" : ""} ${className}`.trim()}
      aria-label={ariaLabel}
      title={title}
      onClick={() => void handleClick()}
      disabled={disabled || isSpinning}
    >
      <i className="ri-refresh-line" />
    </button>
  );
}
